import Vue from "vue";

import VueI18n from "vue-i18n";

Vue.use(VueI18n);
import vi from "./vi";
import zh from "./zh";
 
var defaultLang = "vi";
try {
    var lang = navigator.language || navigator.userLanguage;
    // lang = lang.substr(0, 2);
    lang = 'vi'
    console.log(lang);

    switch (lang) {
        case "vi":
            defaultLang = "vi";
            break;
        case "th":
            defaultLang = "th";
            break;
        case "zh":
            defaultLang = "zhHans";
            break;
        case "ar":
            defaultLang = "ar";
            break;
        default:
            defaultLang = "vi";
            break;
    }
} catch (error) {
    defaultLang = "vi";
}
// Vue.use(AppInfo);
const messages = {
    zhHans: {
        ...zh,
    },
    vi: {
        ...vi,
    },
};

var sysLang = defaultLang;

if (localStorage.getItem('i18n')) sysLang = localStorage.getItem('i18n');
else if (process.env.VUE_APP_LANG && process.env.VUE_APP_LANG !== 'undefined' && process.env.VUE_APP_LANG !== 'null' && process.env.VUE_APP_LANG !== '') {
    sysLang = process.env.VUE_APP_LANG;
}
// 使用选项创建 VueI18n 实例
console.log('使用选项创建 VueI18n 实例');
const i18n = new VueI18n({
    locale: sysLang, // set locale
    messages,
});
i18n.setLang = (lang) => {
    i18n.locale = lang;
    return lang;
};
export default i18n;
